import Tween from 'tween.ts';
import {rootEventBus, EnumRootEventBus} from "../managers/RootEventBus";


export default class Animation {
  static instance: Animation;
  static isCancelled: boolean = false;
  rootEventBus = rootEventBus;
  EnumRootEventBus = EnumRootEventBus;
  
  constructor() {
    if (!Animation.instance) Animation.instance = this;
    this.rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => Animation.isCancelled = false);
    this.rootEventBus.on(EnumRootEventBus.cancelledCircleAnim, () => {
       Animation.isCancelled = true;
       setTimeout(() => {
        Animation.isCancelled = false;
        this.rootEventBus.emit(EnumRootEventBus.completedCircleAnim)
       }, 0);
    });
    this.rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => Animation.isCancelled = false);
  }

  update = (delta: number) => Tween.update(delta);
  getIsCancelled = () => Animation.isCancelled;
  static getInstance = () => Animation.instance;
}